import "@hotwired/turbo-rails"
import "./controllers"
import * as ActiveStorage from "@rails/activestorage"
import "./facebook_pixel"

ActiveStorage.start()






import "@37signals/lexxy"
